// extracted by mini-css-extract-plugin
export default {"tips":"index_tips__CKmRI","tips_container":"index_tips_container__WzCTe","tips_title":"index_tips_title__B9ydI","tips_desc":"index_tips_desc__weknh"};